import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
    { to: "/about", label: "About" },
    { to: "/status", label: "Status" },
    { to: "/accessibility", label: "Accessibility" },
    { to: "/sitemap", label: "Sitemap" },
    { to: "/resources", label: "Resources" },
    { to: "/terms", label: "T&C" },
];

// Single-line footer: copyright on the left, links on the right.
function Footer() {
    return (
        <footer className="w-full border-t border-ink/10 dark:border-paper/15">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
                <div className="flex flex-col md:flex-row items-center justify-between gap-3 font-plex-mono text-[11px] uppercase tracking-[0.16em]">
                    <p className="text-ink/55 dark:text-paper/55">
                        © {new Date().getFullYear()} Zeffert &amp; Associates. All rights reserved.
                    </p>
                    <nav aria-label="Footer" className="flex flex-wrap justify-center gap-x-6 gap-y-2">
                        {LINKS.map(({ to, label }) => (
                            <Link
                                key={to}
                                to={to}
                                className="link-underline text-[11px] text-ink/55 hover:text-ink dark:text-paper/55 dark:hover:text-paper transition-colors"
                            >
                                {label}
                            </Link>
                        ))}
                    </nav>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
